import {
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-not-enough-access-keys',
    templateUrl: './not-enough-access-keys.component.pug',
    styleUrls: ['./not-enough-access-keys.component.less']
})
export class NotEnoughAccessKeysComponent {
    @Output() confirm: EventEmitter<any> = new EventEmitter();
    @Output() cancel: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    onConfirm() {
        this.confirm.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
